const isMobile = () => window.matchMedia('(max-width: 512px)').matches;

export default isMobile;
